import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScansService } from './services/scans.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    ScansService
  ]
})
export class ScansModule { }
